import ServiceRequest from './service-request.container'

export default ServiceRequest